import api from "app/api";
import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { ExchangeRateItem } from "./exchangeRateApi";
export type Currency = "HUF" | "EUR";
export type ExchangeRateState = {
  currency: Currency;
  setCurrency: (currency: Currency) => void;
  load: () => Promise<void>;
  exchangeRate?: ExchangeRateItem;
  getEur(v: any): any;
  getHUF(v: any): any;
  getVal(v: any): any;
};

const ExchangeRateContext = createContext<ExchangeRateState>({} as any);

export interface ExchangeRateProviderProps {
  children: any;
}
export default function ExchangeRateProvider({
  children,
}: ExchangeRateProviderProps) {
  const [exchangeRate, setExchangeRate] = useState<ExchangeRateItem>();
  const [currency, setCurrency] = useState<Currency>("EUR");

  function getEur(v: any) {
    if (currency === "HUF" && exchangeRate) {
      return parseFloat(v || 0) / exchangeRate.rate;
    } else {
      return v;
    }
  }
  function getHUF(v: any) {
    if (currency === "HUF" && exchangeRate) {
      return Math.round(exchangeRate.rate * parseFloat(v || 0));
    } else {
      return v;
    }
  }
  function getVal(v: any) {
    if (currency === "HUF") {
      return getHUF(v);
    } else {
      return getEur(v);
    }
  }

  async function load() {
    const { success, data, error } = await api.get("/rates/get-rate", {
      params: {
        type: "HUF_EUR",
        date: new Date(),
      },
    });
    if (success) {
      setExchangeRate(data);
    } else {
      console.log(`Error: ${error?.error?.message || "Ismeretlen hiba"}`);
    }
  }
  useEffect(() => {
    load();
  }, []);

  const context = useMemo(() => {
    return {
      exchangeRate,
      currency,
      setCurrency,
      load,
      getEur,
      getHUF,
      getVal,
    };
  }, [currency, exchangeRate]);

  return (
    <ExchangeRateContext.Provider value={context}>
      {children}
    </ExchangeRateContext.Provider>
  );
}

export function useExchangeRate(): ExchangeRateState {
  const context = useContext(ExchangeRateContext);
  if (!context) {
    return {} as any;
  }
  return context;
}
